var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.31 29.04V22.4L13 21L10.33 22.4V29.04H15.31Z",
    fill: "#7D4533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 6H6.34L9.5 22.61H24.49C24.8878 22.61 25.2694 22.452 25.5507 22.1707C25.832 21.8894 25.99 21.5078 25.99 21.11V11.84C25.98 8.61 23.37 6 20.15 6Z",
    fill: "#5092FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34 6C3.11 6 0.5 8.61 0.5 11.84V21.11C0.5 21.5078 0.658035 21.8894 0.93934 22.1707C1.22064 22.452 1.60218 22.61 2 22.61H10.67C11.0678 22.61 11.4494 22.452 11.7307 22.1707C12.012 21.8894 12.17 21.5078 12.17 21.11V11.84C12.17 8.61 9.56 6 6.34 6Z",
    fill: "#3F5FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77 19.0001H3.48C2.94 19.0001 2.5 19.4401 2.5 19.9801C2.5 20.5201 2.94 20.9601 3.48 20.9601H7.77C8.31 20.9601 8.75 20.5201 8.75 19.9801C8.75147 19.851 8.72713 19.7229 8.6784 19.6033C8.62968 19.4837 8.55755 19.3751 8.46625 19.2838C8.37495 19.1925 8.26633 19.1204 8.14677 19.0717C8.0272 19.0229 7.89911 18.9986 7.77 19.0001Z",
    fill: "#1345B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.632 1H17.368C16.893 1 16.5 1.369 16.5 1.816V4.184C16.5 4.631 16.893 5 17.369 5H22.631C23.107 5 23.5 4.631 23.5 4.184V1.816C23.5 1.369 23.108 1 22.632 1Z",
    fill: "#F92F60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 1.58012C15.71 0.910117 16.25 0.370117 16.92 0.370117C17.59 0.370117 18.13 0.910117 18.13 1.58012V10.4841C18.5915 10.7504 18.9522 11.1616 19.1561 11.6538C19.36 12.146 19.3958 12.6918 19.2579 13.2064C19.12 13.7211 18.8162 14.1758 18.3935 14.5001C17.9707 14.8245 17.4528 15.0002 16.92 15.0001C16.3872 15.0002 15.8693 14.8245 15.4466 14.5001C15.0239 14.1758 14.72 13.7211 14.5821 13.2064C14.4442 12.6918 14.48 12.146 14.6839 11.6538C14.8879 11.1616 15.2486 10.7504 15.71 10.4841V1.58012Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.294a6c5629782ffb74be91b7dd54e545.svg";
export { ForwardRef as ReactComponent };